<div
  class="image-full-screen"
  tabindex="0"
  (keyup)="goBackWithKey($event)"
  #imageFullScreen
>
  <div class="image-full-screen__slider">
    <mat-slider
      min="1"
      max="2"
      step="0.1"
      #ngSlider
    >
      <input
        matSliderThumb
        [value]="zoomValue"
        (change)="onChangeZoomValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})"
        #ngSliderThumb="matSliderThumb"
      />
    </mat-slider>
  </div>

  <div
    class="image-full-screen__active-image"
    id="imageFullScreenContainer"
    [ngClass]="{'open': toggleAnnotationPointContainer}"
  >
    @if (!toggleAnnotations && container) {
      <app-active-media
        [activeMedia]="mediaContainer.currentMediaType.mediaElements[mediaContainer.currentMediaType.currentMediaIndex].mediaObject"
        [zoomValue]="zoomValue"
        [container]="container"
        [fullscreen]="true"
      ></app-active-media>
    }
    @else if (toggleAnnotations && curAnn.annotateImage) {
     <app-active-annotate-image
       [curAnn]="curAnn"
       [imgIndex]="mediaContainer.currentMediaType.currentMediaIndex"
       [zoomValue]="zoomValue"
       [lockHeight]="false"
       [largeImg]="true"
       [container]="container"
       [edit]="false"
     ></app-active-annotate-image>
    }
  </div>

  @if (toggleAnnotations) {
    <a
      class="image-full-screen__annotation-points-button"
      (click)="toggleAnnotationPoints()"
      [ngClass]="{'open': toggleAnnotationPointContainer}"
    >
      <mat-icon>
        {{toggleAnnotationPointContainer ? 'navigate_before' : 'navigate_next'}}
      </mat-icon>
    </a>
  }

  @if (toggleAnnotationPointContainer) {
    <div class="image-full-screen__annotation-points-slideIn">
      <span class="image-full-screen__annotation-points-title">
        {{ 'TRANS__ANNOTATION__ANNOTATION_POINTS' | translate }}
      </span>

      <ul class="image-full-screen__annotation-points-items">
        @for (annotation of curAnn.annotations; track $index) {
          <li class="image-full-screen__annotation-points-item">
            <span>
              {{$index + 1}}. {{annotation.description.description}}
            </span>
          </li>
        }
      </ul>
    </div>
  }

  <button
    mat-icon-button
    class="image-full-screen__close"
    (click)="goBack()"
  >
    <mat-icon>
      close
    </mat-icon>
  </button>
</div>

